import { apiFetch } from './client.js';

export type TenantRole = 'owner' | 'admin' | 'member' | 'viewer';

export interface TenantMember {
  userId: string;
  email: string;
  username: string;
  name: string;
  role: TenantRole;
  joinedAt: string;
  lastLoginAt: string | null;
}

export async function listTenantMembers(): Promise<{ members: TenantMember[] }> {
  return await apiFetch<{ members: TenantMember[] }>('/api/v1/tenant/members');
}

export async function changeTenantMemberRole(
  userId: string,
  role: 'admin' | 'member' | 'viewer',
): Promise<{ ok: boolean; role: TenantRole }> {
  return await apiFetch<{ ok: boolean; role: TenantRole }>(
    `/api/v1/tenant/members/${userId}`,
    { method: 'PATCH', body: { role } },
  );
}

export async function removeTenantMember(userId: string): Promise<{ ok: boolean }> {
  return await apiFetch<{ ok: boolean }>(`/api/v1/tenant/members/${userId}`, {
    method: 'DELETE',
  });
}
